import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchFilter',
  pure:false
})
export class FilterPipe implements PipeTransform {
  transform(value: any,args: any,from?): any {

      if (!value || !args)
          return value;
      if(from === 'applicationDashboard') {
          return FilterPipe.filter(value, args,from);
      } else {
          return FilterPipe.filter(value, args);
      }
  }


  static filter(items, term,from?) {
      const /** @type {?} */ toCompare = (term.trim()).toLowerCase();
      /**
       * @param {?} item
       * @param {?} term
       * @return {?}
       */
      function checkInside(item, term,from?) {
          for (let /** @type {?} */ property in item) {
              if (item[property] === null || item[property] == undefined) {
                  continue;
              }
              if (typeof item[property] === 'object') {
                  if (checkInside(item[property], term)) {
                      return true;
                  }
              }

              if(from && from === 'applicationDashboard') {
                if(property === 'name' || property === 'searchTags' || property === 'description' || property === 'subType' || property === 'createdBy') {
                  if (item[property].toString().toLowerCase().includes(toCompare)) {
                    return true;
                  }
                }

              } else {
                if(property === 'accountName' || property === 'workspaceName') {
                  if (item[property].toString().toLowerCase().includes(toCompare)) {
                   return true;
                  }
                }
              }
          }
          return false;
      }

      return items.filter(function (item) {
        if(from && from === 'applicationDashboard') {
          return checkInside(item, term,from);
        } else {
          return checkInside(item, term);
        }
      });
  }
  }

